"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableRowsByColumn = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _html = require("../html");

var _ExpandableColumn = require("./ExpandableColumn");

var _core = require("@emotion/core");

var _excluded = ["data", "index", "isExpanded", "isStriped", "expandableContentHasBackgroundColor", "expandableRowHasTopBorder", "isSorted", "spacing", "columns", "maxExpandableRows", "ariaLabel", "actionColumnIndex", "isActionCustomPosition"];

var ExpandableRowsByColumn = function ExpandableRowsByColumn(_ref) {
  var data = _ref.data,
      index = _ref.index,
      isExpanded = _ref.isExpanded,
      isStriped = _ref.isStriped,
      expandableContentHasBackgroundColor = _ref.expandableContentHasBackgroundColor,
      expandableRowHasTopBorder = _ref.expandableRowHasTopBorder,
      isSorted = _ref.isSorted,
      spacing = _ref.spacing,
      columns = _ref.columns,
      maxExpandableRows = _ref.maxExpandableRows,
      ariaLabel = _ref.ariaLabel,
      actionColumnIndex = _ref.actionColumnIndex,
      isActionCustomPosition = _ref.isActionCustomPosition,
      trProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _toConsumableArray2.default)(Array(maxExpandableRows)).map(function (_, expandableRowIndex) {
    return (0, _core.jsx)(_html.TrElement, (0, _extends2.default)({}, trProps, {
      key: expandableRowIndex,
      isExpandableContent: true,
      hasBackgroundColor: isStriped || expandableContentHasBackgroundColor,
      hasTopBorderWhenExpanded: expandableRowHasTopBorder && isExpanded
    }), columns.map(function (column, index) {
      return (0, _core.jsx)(_ExpandableColumn.ExpandableColumn, {
        key: index,
        expandableRowIndex: expandableRowIndex,
        actionColumnIndex: actionColumnIndex,
        ariaLabel: ariaLabel,
        colIndex: index,
        columns: columns,
        data: data,
        expandableRowHasTopBorder: expandableRowHasTopBorder,
        isActionCustomPosition: isActionCustomPosition,
        isExpanded: isExpanded,
        isSorted: isSorted,
        isStriped: isStriped,
        spacing: spacing,
        columnProps: column
      });
    }), // Add an empty action cell if actionColumnIndex is not passed
    !isActionCustomPosition && (0, _core.jsx)(_html.TdElement, null));
  }));
};

exports.ExpandableRowsByColumn = ExpandableRowsByColumn;